























































import ModalMixin from '@/mixins/modal.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { Component, Mixins, Watch } from 'vue-property-decorator';

@Component
export default class UserRoleModal extends Mixins(ModalMixin) {
  form!: CrsForm<'userRoles', 'create' | 'update'>;

  groups = [
    {
      label: 'GENERAL.COMPANY',
      permissions: ['CREATE_COMPANY', 'EDIT_COMPANY', 'VIEW_COMPANY'],
    },
    {
      label: 'GENERAL.USER_ROLE',
      permissions: ['VIEW_ROLE', 'CREATE_ROLE', 'EDIT_ROLE'],
    },
    {
      label: 'GENERAL.USER',
      permissions: ['VIEW_USER', 'CREATE_USER', 'EDIT_USER'],
    },
    {
      label: 'GENERAL.PROPERTY',
      permissions: [
        'VIEW_PROPERTY',
        'CREATE_PROPERTY',
        'EDIT_PROPERTY',
        'UPLOAD_PROPERTY_IMAGE',
        'VIEW_CONTRACT',
        'CREATE_CONTRACT',
        'EDIT_CONTRACT',
        'VIEW_SPO',
        'CREATE_SPO',
        'EDIT_SPO',
      ],
    },
    {
      label: 'GENERAL.GEO_INFO',
      permissions: ['VIEW_GEO_INFO'],
    },
    {
      label: 'GENERAL.CURRENCY',
      permissions: [
        'VIEW_CURRENCY',
        'CREATE_CURRENCY',
        'EDIT_CURRENCY',
        'DELETE_CURRENCY',
        'VIEW_EXCHANGE_RATES',
        'CONVERT_EXCHANGE_RATES',
      ],
    },
    {
      label: 'GENERAL.MARKET',
      permissions: ['CREATE_MARKET', 'EDIT_MARKET', 'VIEW_MARKET'],
    },
    {
      label: 'GENERAL.BANK',
      permissions: ['CREATE_BANK', 'EDIT_BANK', 'VIEW_BANK'],
    },
    {
      label: 'GENERAL.GLOBAL_DEFINITION',
      permissions: ['CREATE_GLOBAL_DEFINITION', 'EDIT_GLOBAL_DEFINITION', 'VIEW_GLOBAL_DEFINITION'],
    },
  ];

  @Watch('mode', { immediate: true })
  switchForm(mode: 'create' | 'update') {
    this.form = this.$crsForm('userRoles', mode, {
      isActive: false,
      name: '',
      permissions: [],
    });
  }

  async getForm() {
    return compass.do('userRoles', 'findOne', { params: { id: this.id } });
  }
}
